import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MapIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Map",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20.95 29.72c-.2 0-.4-.05-.57-.15l-9.34-5.39-9.33 5.39c-.35.21-.79.21-1.15 0-.35-.2-.57-.58-.57-.99V9.15c0-.41.22-.79.57-.99l9.92-5.72c.35-.21.79-.21 1.15 0l9.9 5.72c.55.32.73 1.02.42 1.56-.32.55-1.02.73-1.56.42l-9.33-5.39-8.77 5.06v16.78l8.18-4.73c.35-.21.79-.21 1.15 0l9.34 5.39 8.76-5.06V5.41l-4.48 2.58A1.145 1.145 0 0 1 24.11 6l6.19-3.57c.36-.2.79-.2 1.15 0 .35.21.57.58.57.99v19.43c0 .41-.22.79-.57.99l-9.9 5.72c-.18.1-.38.15-.57.15Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.05 24c-.63 0-1.15-.51-1.15-1.14V3.43c0-.63.51-1.14 1.15-1.14s1.15.51 1.15 1.14v19.42c0 .63-.51 1.14-1.15 1.14ZM20.95 29.72c-.63 0-1.14-.51-1.14-1.14V9.15a1.14 1.14 0 1 1 2.28 0v19.43c0 .63-.51 1.14-1.14 1.14"
    })]
  }));
};
MapIcon.displayName = 'MapIcon';